function Link(data) {
  window.location.href=data;
}
module.exports = Link;